import React from "react";
import useKeyboard from "../hooks/ui/useKeyboard";

export default function LoungeHeading ({title, description, children}){

    const {keyboard} = useKeyboard();

    return (
        <div className={`text-left ${keyboard ? 'mt-36 md:mt-0':''}`}>
            <h1 className="text-white font-bold text-2xl">{title}</h1>
            {children}
            {/* <p className="text-gray-400 mb-8 text-left text-base lg:text-base md:text-sm">{description}</p> */}
        </div>
    )
}
